<div class="container-fluid p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">
          {{
            ["makeI", "makeII", "makeIII"].includes(schemeType)
              ? "Shortlisting DA's"
              : "Shortlisting Vendors"
          }}
        </h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span
            class="badge"
            [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }"
          >
            {{
              stepDetails?.step_status == 0
                ? "INITIATION PENDING"
                : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_initiator">
          <button class="btn btn-success" (click)="IRA.emit('Initiate')">
            <i class="pi pi-play me-1"></i> Initiate
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_approver">
          <button class="btn btn-success" (click)="IRA.emit('Approve')">
            <i class="pi pi-check-circle me-1"></i> Approve
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_recommender">
          <button class="btn btn-info" (click)="IRA.emit('Recommend')">
            <i class="pi pi-thumbs-up me-1"></i> Recommend
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />

  <p-accordion [multiple]="false">
    <ng-container *ngFor="let vendor of vendors; let i = index">
      <p-accordionTab>
        <ng-template pTemplate="header">
          <div
            class="rounded-top d-flex justify-content-between align-items-center gap-2 w-100"
          >
            <span class="font-bold whitespace-nowrap"
              >{{ vendor.vendor.name }}
              <span
                *ngIf="vendor.vendor_status"
                class="p-ml-2"
                [ngClass]="{
                  'text-success':
                    vendor.vendor_status === 'Qualified' ||
                    vendor.vendor_status === 'Qualify',
                  'text-danger':
                    vendor.vendor_status === 'Disqualified' ||
                    vendor.vendor_status === 'Disqualify'
                }"
              >
                - ({{
                  vendor.vendor_status === "Qualify"
                    ? "Qualified"
                    : vendor.vendor_status === "Disqualify"
                    ? "Disqualified"
                    : vendor.vendor_status
                }})
              </span></span
            >

            <div class="d-flex gap-2 align-items-center">
              @if (stepDetails?.is_initiator || stepDetails?.is_approver ||
              stepDetails?.is_recommender|| (stepDetails?.step_status !=
              'approved' && userID == 6)) {
              <div class="d-flex gap-2">
                <button
                  class="p-button-success p-mr-2"
                  (click)="
                    $event.stopPropagation();
                    vendorStatusupdate(
                      'Qualify',
                      vendor.documents[0].id,
                      vendor.vendor.id
                    )
                  "
                >
                  Qualify
                </button>
                <button
                  class="p-button-danger"
                  (click)="
                    $event.stopPropagation();
                    vendorStatusupdate(
                      'Disqualify',
                      vendor.documents[0].id,
                      vendor.vendor.id
                    )
                  "
                >
                  Disqualify
                </button>
              </div>
              } @if (activeIndex === i) {
              <i class="pi pi-minus"></i>
              } @else {
              <i class="pi pi-plus"></i>
              }
            </div>
          </div>
        </ng-template>

        <div class="vendor-criteria-table m-3">
          <p-table [value]="vendor.documents" styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
              <tr>
                <th class="wid-5-percent">S.No</th>
                <th class="wid-75-percent">Criteria</th>
                <th class="wid-10-percent">Document</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-doc let-rowIndex="rowIndex">
              <tr>
                <td>{{ rowIndex + 1 }}</td>
                <td>{{ doc.name }}</td>
                <td>
                  <div class="d-flex gap-2" *ngIf="doc.document != null">
                    <a [href]="apiUrl + doc.document" target="_blank">
                      <p-button
                        icon="pi pi-eye"
                        styleClass="p-button-sm p-button-outlined"
                        pTooltip="View Document"
                      >
                      </p-button>
                    </a>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-accordionTab>
    </ng-container>
  </p-accordion>
</div>
